var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpwardsArrowDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 3.02796L19.3453 14.6763L15.7023 13.3526C12.8209 19.4065 13.0324 26.3014 18.8528 30.8437C10.3547 27.7825 8.08537 19.0415 9.1747 10.9807L5.46957 9.63437L15.7241 3.02796Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardsArrowDefault);
export default __webpack_public_path__ + "static/media/upwards-arrow-default.1c3e0713460e6f7cfae3cf7f6fbec7e5.svg";
export { ForwardRef as ReactComponent };